import { motion } from "framer-motion";

export function Eyebrow({
  children,
  dark = false,
  className = "",
}) {
  return (
    <div className={`${dark ? "eyebrow-dark" : "eyebrow"} ${className}`}>
      <span
        className="inline-block w-6 h-px align-middle mr-3"
        style={{
          background: dark
            ? "var(--p10-electric)"
            : "var(--p10-royal)",
        }}
      />
      {children}
    </div>
  );
}

export function SectionHeader({
  eyebrow,
  title,
  intro,
  align = "left",
  dark = false,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{
        duration: 0.7,
        ease: [0.2, 0.7, 0.2, 1],
      }}
      className={`max-w-4xl ${
        align === "center" ? "mx-auto text-center" : ""
      }`}
    >
      {eyebrow && (
        <Eyebrow dark={dark} className="mb-6">
          {eyebrow}
        </Eyebrow>
      )}

      <h2
        className={`font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] ${
          dark
            ? "text-white"
            : "text-[color:var(--p10-ink)]"
        }`}
      >
        {title}
      </h2>

      {intro && (
        <p
          className={`mt-6 text-lg leading-relaxed max-w-2xl ${
            dark
              ? "text-white/70"
              : "text-[color:var(--p10-ink)]/70"
          } ${align === "center" ? "mx-auto" : ""}`}
        >
          {intro}
        </p>
      )}
    </motion.div>
  );
}

export function Reveal({
  children,
  delay = 0,
  className = "",
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{
        duration: 0.7,
        delay,
        ease: [0.2, 0.7, 0.2, 1],
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
}